// AI-ASSISTED: generated with claude-code on 2026-06-29, reviewed by Yoann Hertienne
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';

export { BitbucketCard } from './BitbucketCard';

const bitbucketCard = EntityCardBlueprint.make({
  name: 'bitbucket',
  params: {
    filter: 'kind:component',
    loader: async () => {
      const { BitbucketCard } = await import('./BitbucketCard');
      return <BitbucketCard />;
    },
  },
});

export const bitbucketCardModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [bitbucketCard],
});
